import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Typography, IconButton} from '@material-ui/core';
import CustomBtn from '../components/CustomBtn';
import NavBar from '../components/navbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';



const useStyles = makeStyles((theme) => ({
    content:{
        padding: '50px 50px 50px 100px',
        maxWidth:'50%'
    },
Question:{
fontFamily:['Nunito'].join(','),
fontSize:'32px',
fontWeight:900,
color:'#153BAB',
paddingTop:'20px',
paddingBottom:'20px'
},
title:{
fontFamily:['Nunito'].join(','),
fontSize:'16px',
fontWeight:600,
color:'#4F5052',
paddingTop:'5px',
paddingBottom:'5px'
},
info:{
    fontFamily:['Nunito'].join(','),
    fontSize:'14px',
    fontWeight:400,
    color:'#4F5052',
    paddingTop:'5px',
    paddingBottom:'5px'
},
btnContainer:{
    paddingTop:'20px'
},
foot:{
     padding: '100px 50px 50px 100px',
},
iconBtn:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
  },
  icon:{
    height:'35px',
    width:'35px',
  },
}));

export default function GitHubLink(props) {
  const classes = useStyles();
    return(
    <div>
        <NavBar type='main'/>
        <IconButton className={classes.iconBtn}><ArrowBackIcon className={classes.icon}/></IconButton>
        <div className={classes.content}>
        <Typography className={classes.Question}>Want to land AI jobs, or elevate your skills?</Typography>

        <Typography className={classes.title}>Hone your AI abilities. </Typography>
        <Typography className={classes.info}>Lyra will tailor a learning path for you 
            & our expert senior consultants will provide you with continuous mentorship.
        </Typography>

        <Typography className={classes.title}>Work on real projects.</Typography>
        <Typography className={classes.info}>You’ll be able to join global AI teams 
        and work on exciting remote projects.</Typography>


        <Typography className={classes.title}>Secure the right AI job for you.</Typography>
        <Typography className={classes.info}>If you qualify and meet requirements, our algorithms 
        can quickly match you with the right remote employer.</Typography>

        <div className={classes.btnContainer}>
        <CustomBtn colorwhite={false} width={'30%'} fntSize={'14px'} txt={'Join Talent Network'}/>
        </div>
        </div>

        <div className={classes.foot}>
        {/* <Footer /> */}
        </div>
        
    </div>  
    );
}
